/**
 * Tools → "Abu Sultan 2.0" per-contract change table (tab option-change-tracker).
 *
 * The page is ContractChangesView, which reads /api/edge/contract-changes (latest chain
 * snapshot joined with the prior-session close on the server). The scanner rows handed in
 * by App only seed the underlying suggestions; the table no longer depends on them.
 */
import React, { useMemo } from 'react';
import type { ScannerData } from '../types/ScannerData';
import type { DataMode } from '../types/DataMode';
import { getFilterOptions } from '../utils/filterUtils';
import ContractChangesView from './edge/ContractChangesView';

export interface OptionChangeTrackerPageProps {
  data?: ScannerData[];
  dataMode?: DataMode;
}

const OptionChangeTrackerPage: React.FC<OptionChangeTrackerPageProps> = ({ data }) => {
  const suggestions = useMemo(() => {
    try {
      return getFilterOptions(data ?? []).availableUnderlyings ?? [];
    } catch {
      return [];
    }
  }, [data]);
  return <ContractChangesView suggestions={suggestions} />;
};

export default OptionChangeTrackerPage;
